import React, { forwardRef } from 'react';
interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  label,
  error,
  className = '',
  ...props
}, ref) => {
  return <div className={`flex flex-col w-full ${className}`} data-id="element-189">
        <label className="text-xs font-medium text-luxury-gray uppercase tracking-wider mb-2 ml-1" data-id="element-190">
          {label}{' '}
          {props.required && <span className="text-luxury-gold" data-id="element-191">*</span>}
        </label>
        <textarea ref={ref} className={`w-full bg-luxury-darkgray/50 border ${error ? 'border-red-500/50' : 'border-white/10'} rounded-xl px-4 py-3.5 text-luxury-white placeholder:text-luxury-gray/50 focus:outline-none focus:border-luxury-gold focus:ring-1 focus:ring-luxury-gold transition-colors resize-y min-h-[120px] allow-select`} {...props} data-id="element-192" />
        {error && <span className="text-xs text-red-400 mt-1.5 ml-1" data-id="element-193">{error}</span>}
      </div>;
});
Textarea.displayName = 'Textarea';